module.exports = __webpack_public_path__ + "static/media/newsify_profolio_image.1c4ffb9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsify_profolio_image.png
// module id = 55
// module chunks = 0